import { TrackingPositionTypes } from '../../components/organisms/navigation/NavigationContext';

export const getPositionString = (
  level: number,
  itemIndex: number,
  positions: TrackingPositionTypes[]
): string => {
  const levelOnePosition = positions[0].position;
  const levelTwoPosition = positions[1].position;
  const levelThreePosition = positions[2].position;

  switch (level) {
    case 1:
      return `${levelOnePosition}|${itemIndex}`;
    case 2:
      return `${levelOnePosition}|${levelTwoPosition}|${itemIndex}`;
    case 3:
      return `${levelOnePosition}|${levelTwoPosition}|${levelThreePosition}|${itemIndex}`;
    default:
      return `${itemIndex}`;
  }
};

export const trackClickEvent = (link?: string) => {
  if (!window.aabTracker || !link) return;

  window.aabTracker.trackEvent({
    event: 'click',
    data: {
      contentInteractionName: 'linkClick',
      linkTitle: `${link}`,
      linkDestination: link,
    },
  });
};
